// removed by extract-text-webpack-plugin
module.exports = {"link":"PopoverElement__link___25zLX _typography__info___3HrS4 _typography__headers___eO5yD","icon":"PopoverElement__icon___2xaYj","link-warning":"PopoverElement__link-warning___1p_2j PopoverElement__link___25zLX _typography__info___3HrS4 _typography__headers___eO5yD","label":"PopoverElement__label___3K9MM"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Overlay/PopoverElement.scss
// module id = 560
// module chunks = 0